export default {
  translation: {
    feedback: {
      uploadRss: 'RSS успешно загружен',
    },
    errors: {
      invalidUrl: 'Ссылка должна быть валидным URL',
      doubledChannel: 'RSS уже существует',
      notRss: 'Ресурс не содержит валидный RSS',
      notConnected: 'Ошибка сети',
      unknownError: 'Что-то пошло не так',
      emptyField: 'Не должно быть пустым',
    },
    createdBy: 'created by',
    myName: 'Aleksei Shvets',
    postTitle: 'Посты',
    feedTitle: 'Фиды',
    viewing: 'Просмотр',

  },
};
